<div class="ui-g">
  <div class="ui-g-6" *ngIf="isVme">
    <div class="header-bar">
      <h1>Task Step Types</h1>
    </div>
    <p-listbox
      name="stepTypes"
      [options]="stepTypesOpts"
      [(ngModel)]="selectedStepTypes"
      multiple="multiply"
      checkbox="checkbox"
      [metaKeySelection]="false"
      styleClass="form-component"
    >
    </p-listbox>
  </div>

  <div class="ui-g-6">
    <div class="header-bar">
      <h1>Mandatory Photo Mapping</h1>
    </div>
    <div class="content-container">
      <div>
        <p-table [value]="photoAreas" [lazy]="false">
          <ng-template pTemplate="header">
            <tr>
              <th>Requested New Photos</th>
              <th>Mandatory</th>
              <th>Required</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ getAreaName(item.area) }}</td>
              <td>
                <span [style.font-weight]="item.isMandatory ? 'bold' : ''">{{
                  item.isMandatory ? 'Yes' : 'NO'
                }}</span>
              </td>
              <td>
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="item.isRequired"
                  [disabled]="item.isMandatory"
                ></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="ui-g">
          <button
            type="button"
            (click)="cancel()"
            pButton
            icon="fa ui-icon-close"
            *ngIf="isVme"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            (click)="submit()"
            icon="fa ui-icon-check"
            class="ui-button green-btn btn-to-right"
            pButton
            label="Save"
            tabindex="46"
            style="width: auto; float: right"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
